import { useLocation } from 'react-router-dom';
// import Image from '@components/Image';
import Header from '@layout/header';
import SandboxNoticeBar from '@layout/SandboxNoticeBar';
import { IconClock } from '@tabler/icons-react';

const ErrorPage = () => {
  const location = useLocation();
  const message =
    location.state?.message || 'Terjadi kesalahan yang tidak diketahui';

  return (
    <div className="min-h-screen overflow-x-hidden bg-neutral-100">
      <SandboxNoticeBar />
      <Header />
      <main className="-mt-[73px] min-h-[calc(100vh-80px)] overflow-hidden px-4 py-6 sm:px-6 lg:px-8">
        <div className="flex min-h-screen items-center justify-center">
          <main className="flex w-full flex-col items-center justify-center gap-4">
            <div className="mx-auto w-full max-w-2xl">
              <div className="mt-4 flex h-fit items-center justify-center rounded-xl bg-white p-4 shadow-sm sm:p-6 lg:p-8">
                <div className="flex w-full flex-col gap-6 sm:gap-8">
                  <div className="flex flex-col items-center gap-4 sm:gap-6">
                    <div className="mx-auto w-fit">
                      <div className="flex h-16 w-16 items-center justify-center rounded-full border-4 border-gray-400 bg-gray-400 sm:h-20 sm:w-20">
                        <IconClock className="h-12 w-12 text-white sm:h-16 sm:w-16" />
                      </div>
                    </div>
                    <div className="flex flex-col items-center gap-1 px-2 text-center sm:gap-2">
                      <span className="text-xl font-semibold text-gray-700 sm:text-2xl lg:text-3xl">
                        Payment Expired
                      </span>
                      <span className="text-sm font-normal text-gray-700 sm:text-base">
                        {message}
                      </span>
                    </div>
                  </div>

                  <div className="flex flex-row items-center justify-center">
                    <div className="flex flex-row items-center justify-center gap-2 text-xs text-gray-500 sm:text-sm">
                      <svg
                        className="h-5 w-5 flex-shrink-0 sm:h-6 sm:w-6"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3 11H6C6.53043 11 7.03914 11.2107 7.41421 11.5858C7.78929 11.9609 8 12.4696 8 13V16C8 16.5304 7.78929 17.0391 7.41421 17.4142C7.03914 17.7893 6.53043 18 6 18H5C4.46957 18 3.96086 17.7893 3.58579 17.4142C3.21071 17.0391 3 16.5304 3 16V11ZM3 11C3 9.8181 3.23279 8.64778 3.68508 7.55585C4.13738 6.46392 4.80031 5.47177 5.63604 4.63604C6.47177 3.80031 7.46392 3.13738 8.55585 2.68508C9.64778 2.23279 10.8181 2 12 2C13.1819 2 14.3522 2.23279 15.4442 2.68508C16.5361 3.13738 17.5282 3.80031 18.364 4.63604C19.1997 5.47177 19.8626 6.46392 20.3149 7.55585C20.7672 8.64778 21 9.8181 21 11M21 11V16C21 16.5304 20.7893 17.0391 20.4142 17.4142C20.0391 17.7893 19.5304 18 19 18H18C17.4696 18 16.9609 17.7893 16.5858 17.4142C16.2107 17.0391 16 16.5304 16 16V13C16 12.4696 16.2107 11.9609 16.5858 11.5858C16.9609 11.2107 17.4696 11 18 11H21Z"
                          stroke="#525252"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M21 16V18C21 19.0609 20.5786 20.0783 19.8284 20.8284C19.0783 21.5786 18.0609 22 17 22H12"
                          stroke="#525252"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <span className="font-light text-[#404040]">
                        Need help?{' '}
                        <span className="font-semibold text-black">
                          Contact Your Merhant
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </main>
    </div>
  );
};

export default ErrorPage;
